import React from 'react';
import { motion } from 'framer-motion';
import { ContactForm } from './ContactForm';
export function Hero() {
  return <section className="relative min-h-screen flex flex-col justify-center items-center pt-24 pb-20 px-4 overflow-hidden" data-id="element-83">
      {/* Background Elements */}
      <div className="absolute inset-0 z-0" data-id="element-84">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-[#0ea5e9]/20 rounded-full blur-[128px]" data-id="element-85" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-[#10b981]/10 rounded-full blur-[128px]" data-id="element-86" />
        <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20" data-id="element-87" />
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto text-center" data-id="element-88">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="mb-12" data-id="element-89">
          <span className="inline-block py-1 px-3 rounded-full bg-[#0ea5e9]/10 text-[#0ea5e9] text-sm font-medium mb-6 border border-[#0ea5e9]/20" data-id="element-90">
            UK Based Web & App Development
          </span>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white tracking-tight mb-6" data-id="element-91">
            Crafting immersive digital experiences{' '}
            <br className="hidden md:block" data-id="element-92" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0ea5e9] to-[#10b981]" data-id="element-93">
              that drive real business results.
            </span>
          </h1>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto mb-8" data-id="element-94">
            We blend technical excellence with award-winning design to build
            websites and mobile apps that scale.
          </p>
        </motion.div>

        {/* Form Container */}
        <div className="w-full max-w-3xl mx-auto" data-id="element-95">
          <ContactForm data-id="element-96" />
        </div>
      </div>
    </section>;
}